
import React from 'react';
import { Hero } from './component/Hero/Hero';
import { CalloutCard } from './component/CalloutCard/CalloutCard';

export default function Home() {
  return (
    <div className="landing-page" style={{ padding: 0, margin: 0, maxWidth: 'none' }}>
      <Hero
        eyebrow="Open Platform · Saline GeoFluids"
        title="Global Database of the Geochemistry of Saline GeoFluids"
        tagline="A global, open database for scientific research and sustainable development"
      />

      <div className="landing-content">
        {/* Two-column layout */}
        <div className="landing-columns">
          {/* LEFT: main content */}
          <main className="landing-main">
            <p className="eyebrow" style={{ marginBottom: 8 }}>Why this platform</p>
            <h2 className="landing-section-heading">A Central Resource for Geofluid Science</h2>

            <p className="landing-body">
              Exploring the Earth{"'"}s geofluids—geothermal waters, oilfield brines, hot springs, and more—offers insights that are critical for research into energy solutions, mineral extraction, and environmental management.
              Geofluid DataHub is an open-access database, bringing together geochemical and physical data from thousands of samples around the world. Our mission is to provide the scientific community with a central, comprehensive platform to access, analyze, and contribute data related to geofluids.
            </p>

            <p className="landing-body">
              The growing global interest in renewable energy, particularly geothermal power, the extraction of critical minerals from brines, and the treatment of waste fluids underscores the need for a centralized, easily accessible repository of geofluid data.
              Geofluid DataHub bridges this gap by compiling data from thousands of published studies and open-access databases, making it available for scientists, policymakers, and engineers.
            </p>

            <h3 className="landing-highlights-heading">Platform Highlights</h3>
            <ul className="landing-highlights">
              <li><strong>Global Dataset:</strong> Over 300,000 samples from across the world, including key data on location, depth, temperature, salinity, major and trace elements, and more.</li>
              <li><strong>Powerful Filtering Tools:</strong> Users can refine the data to match specific research criteria—by fluid type, country, or chemical composition—allowing for highly customizable data exploration.</li>
              <li><strong>Collaboration &amp; Contribution:</strong> Researchers are encouraged to contribute their datasets to foster collaboration and growth of the global geofluid database.</li>
            </ul>

            <p className="landing-body" style={{ marginTop: 24 }}>
              We invite you to explore the data, make new discoveries, and contribute your own research to support a shared goal of advancing geofluid science for a sustainable future.
            </p>

            <div className="landing-cta-row">
              <a href="/data" className="cta-btn">Explore Database</a>
              <a href="/contribute" className="btn-ghost">Contribute Data</a>
            </div>
          </main>

          {/* RIGHT: aside */}
          <aside className="landing-aside">
            <CalloutCard
              title="GeoFluid Index"
              actionLabel="Learn More"
              actionHref="/references"
            >
              Browse the catalog of geochemical sources and supporting publications.
            </CalloutCard>

            <nav className="landing-quick-links">
              <p className="eyebrow" style={{ marginBottom: 10 }}>Quick Links</p>
              <ul>
                <li><a href="/references">Data Sources</a></li>
                <li><a href="/contribute">Submission Form</a></li>
                <li><a href="/contribute">QAQC Checklist</a></li>
              </ul>
            </nav>
          </aside>
        </div>
      </div>
    </div>
  );
}
